import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "components/common/Box";
import Text from "components/common/Text";
import { useHistory } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "components/common/Button";
import Stack from "components/common/Stack";
import TextField from "components/common/TextField";
import { Formik } from "formik";
import * as yup from "yup";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Switch from "../../common/Switch";
import CTable from "components/common/Table";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const AddConnectors = ({
  data,
  isLoading,
  onClickEdit,
  submitConnectors,
  handleStatusConnectors,
}) => {
  const classes = useStyles();

  const initialValues = {
    connectorsname: "",
    file: null,
  };

  const validateConnectorForm = yup.object().shape({
    connectorsname: yup
      .string()
      .required("Connector name is required")
      .trim("Connector cannot contain extra spaces")
      .strict(true)
      .matches(
        /[a-zA-Z0-9]+$/,
        "Only alphabets and number are allowed for this field "
      ),

    file: yup
      .mixed()
      .required("upload image in only jpeg/jpg/png format")
      .test(
        "FILE_SIZE",
        "Image size should be less than 1 MB",
        (value) => !value || (value && value.size <= 1024 * 1024)
      ),
  });

  let history = useHistory();

  const columns = [
    {
      field: "name",
      headerName: "Name of Connectors",
    },

    {
      field: "price",
      headerName: "Action",
      valueGetter: (v, d) => {
        return (
          <>
            {
              <>
                <EditOutlinedIcon
                  className={classes.connectoricon}
                  onClick={() => {
                    onClickEdit(d.id, d.name);
                  }}
                  sx={{
                    cursor: "pointer",
                    color: "#004AAD",
                    marginLeft: "36%",
                    marginBottom: "-10px",
                  }}
                />

                {
                  <Switch
                    checked={d.status === 1 ? true : false}
                    onClick={() =>
                      handleStatusConnectors(d.id, d.status, d.name)
                    }
                  />
                }
              </>
            }
          </>
        );
      },
    },
  ];

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          let formData = new FormData();
          formData.append("name", values.connectorsname);
          formData.append("file", values.file);
          submitConnectors(formData);
          values.connectorsname = "";
        }}
        validationSchema={validateConnectorForm}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isValid,
          values,
          touched,
          errors,
        }) => (
          <>
            <Text
              variant="h5"
              color="#202020"
              sx={{
                fontSize: "24px",
                fontWeight: "bold",
                marginBottom: "40px",
              }}
            >
              <ArrowBackIcon
                sx={{
                  fontSize: "22px",
                  fontWeight: "bold",
                  marginRight: "10px",
                }}
                onClick={() => history.goBack()}
              />
              Add Connectors
            </Text>

            <Grid container rowSpacing={1}>
              <Grid xs={6}>
                <Text sx={{ color: "#666666", fontSize: "14px" }}>
                  Enter Connector Name
                </Text>
                <Box sx={{ width: "300px" }}>
                  <TextField
                    size="small"
                    onChange={handleChange("connectorsname")}
                    onBlur={handleBlur("connectorsname")}
                    value={values.connectorsname}
                    error={
                      !touched.connectorsname && Boolean(errors.connectorsname)
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value.trimStart();
                    }}
                  />
                  {errors.connectorsname && (
                    <Typography sx={{ color: "red" }}>
                      {errors.connectorsname}
                    </Typography>
                  )}
                </Box>
              </Grid>

              <Grid xs={6}>
                <Text sx={{ color: "#666666", fontSize: "14px" }}>
                  Add Connector Image
                </Text>
                <Box sx={{ width: "500px" }}>
                  <Box
                    sx={{
                      width: "300px",
                      height: "25px",
                      border: "1px solid rgba(0, 0, 0, 0.27)",
                      padding: "10px 10px",
                      borderRadius: "5px",
                    }}
                  >
                    <input
                      id="file"
                      name="photo"
                      type="file"
                      accept="image/*"
                      className="form-control"
                      onChange={(event) => {
                        setFieldValue("file", event.currentTarget.files[0]);
                      }}
                      error={!touched.file && Boolean(errors.file)}
                    />
                  </Box>

                  {errors.file && (
                    <Typography sx={{ color: "red" }}>{errors.file}</Typography>
                  )}
                </Box>
              </Grid>
            </Grid>

            <Stack mt={1.5}>
              <Button
                variant="outlined"
                sx={{
                  width: "94.17px",
                  height: "51.41px",
                  fontSize: "16px",
                  borderColor: "#0071C5",
                  color: "#0071C5",
                }}
              
                onClick={() => {
                  handleSubmit();
                }}
                disabled={!isValid}
              >
                + Add
              </Button>
            </Stack>

            <Stack mt={5}>
            
              <br></br>
              <CTable
                columns={columns}
                data={data}
                isLoading={isLoading}
                pagination={true}
                localPagination={true}
                page={0}
                rowsPerPage={5}
              ></CTable>
            </Stack>
          </>
        )}
      </Formik>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  connectoricon: {
    "@media (max-width:768px)": {
      marginLeft: "-18px",
      marginBottom: "-9px",
    },
  },
}));

export default AddConnectors;
